var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#F2F0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 0.755529C3.244 2.45801 0 6.85017 0 12C0 17.1498 3.244 21.542 7.8 23.2445V0.755529Z",
    fill: "#6EA644"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 23.2445C20.756 21.542 24 17.1498 24 12C24 6.85017 20.756 2.45801 16.2 0.755529L16.2 23.2445Z",
    fill: "#D90026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalian);
export default __webpack_public_path__ + "static/media/italian.1731c0b07d2f3daeeb74fb321aaed3f9.svg";
export { ForwardRef as ReactComponent };